import { Box, Button, Card, Grid } from "@mui/material";

import { useState } from "react";
type CardValue = "WAYSTAR" | "CLAIM_MD" | "STEDI";

import waystarColor from "/public/claims/Waystar-Logo-SVG-selected.svg";
import waystarDisable from "/public/claims/Waystar-Logo-SVG-Not-Selected.svg";
import claimMdColor from "/public/claims/Claim -MD-SVG-Selected.svg";
import claimMdDisable from "/public/claims/Claim-MD-SVG-Not-Selected.svg";
import Text from "../../../../../../components/Text";
import { DisclosureHost } from "../../../../../../hooks/use-disclosure";
import Flex from "../../../../../../components/Flex";
import StyledDialog from "../../../../../../components/StyledDialog";
import stediDisable from "/public/claims/stedi-md-inactive.svg";
import stediMdColor from "/public/claims/stedi-md-active.svg";
import { getXtenantId } from "../../../../../../utils/utils";
import { useGetClaimIntegration } from "../../../../../../queries/billings/claim-integration/use-get-claim-integration";

type Card = {
  value: CardValue;
  name: string;
  active: string;
  disable: string;
};

interface NavSelectClaimTypeModalProps {
  disclosureHost: DisclosureHost;
  onNextClick: (v: CardValue | null) => void;
}

const CARD_DATA: Partial<Record<CardValue, Card>> = {
  WAYSTAR: {
    name: "Waystar",
    value: "WAYSTAR",
    active: waystarColor,
    disable: waystarDisable,
  },
  CLAIM_MD: {
    name: "Claim MD",
    value: "CLAIM_MD",
    active: claimMdColor,
    disable: claimMdDisable,
  },
  STEDI: {
    name: "Stedi",
    value: "STEDI",
    active: stediMdColor,
    disable: stediDisable,
  },
};

const NavSelectClaimTypeModal = ({
  disclosureHost,
  onNextClick,
}: NavSelectClaimTypeModalProps) => {
  const [curActiveCard, setCurActiveCard] = useState<CardValue | null>(null);

  const { data: claimIntegrationList } = useGetClaimIntegration({
    xtenantId: getXtenantId() ?? "",
  });

  // Only show vendors that are configured (non-archived) and resolve to a known card
  const configurableCards: Card[] = (
    ((claimIntegrationList as any)?.data as any[]) ?? []
  )
    .filter((it) => !it?.archive && CARD_DATA[it?.vendor as CardValue])
    .map((it) => CARD_DATA[it?.vendor as CardValue]!);

  return (
    <StyledDialog
      open={disclosureHost.opened}
      dialogTitle={"Please select claim vendor for submission."}
      onClose={() => {
        disclosureHost.close();
        setCurActiveCard(null);
      }}
      dialogAction={
        <Flex gap={"20px"}>
          <Button
            sx={{ width: "6.25rem" }}
            onClick={() => onNextClick(curActiveCard)}
            variant="contained"
          >
            Submit
          </Button>
        </Flex>
      }
    >
      <Box width={"36.75rem"} mt={"5rem"} style={{ height: "350px" }}>
        <Grid container spacing={3} justifyContent={"space-evenly"}>
          {configurableCards?.map((it) => (
            <Grid
              key={it.value}
              style={{ cursor: "pointer" }}
              item
              xs={4}
              onClick={() => {
                setCurActiveCard(it.value);
              }}
              width="180px"
            >
              {it.value === curActiveCard ? (
                <img
                  src={it.active}
                  width="120"
                  height="120"
                  alt={`${it.name} active`}
                  style={{ display: "block", margin: "0 auto" }}
                />
              ) : (
                <img
                  src={it.disable}
                  width="120"
                  height="120"
                  alt={`${it.name} inactive`}
                  style={{ display: "block", margin: "0 auto" }}
                />
              )}
              <Text px={"2rem"} mt={"10px"} textAlign={"center"}>
                {it.name}
              </Text>
            </Grid>
          ))}
        </Grid>
      </Box>
    </StyledDialog>
  );
};

export default NavSelectClaimTypeModal;
